/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { startSKApp } from "./index";

// Monaco Worker-Konfiguration - einmalig beim App-Start
// Worker-Dateien liegen in static/js/ (funktioniert in Dev UND Production)
if (typeof window !== 'undefined' && !window.MonacoEnvironment) {
  window.MonacoEnvironment = {
    getWorkerUrl: function (moduleId, label) {
      const basePath = '/static/js/';
      if (label === 'json') {
        return basePath + 'json.worker.js';
      }
      if (label === 'css' || label === 'scss' || label === 'less') {
        return basePath + 'css.worker.js';
      }
      if (label === 'html' || label === 'handlebars' || label === 'razor') {
        return basePath + 'html.worker.js';
      }
      if (label === 'typescript' || label === 'javascript') {
        return basePath + 'ts.worker.js';
      }
      return basePath + 'editor.worker.js';
    }
  };
}

export function initSKStarterOnGlobal() {
  window.startSKApp = startSKAppStarter;
}

const startSKAppStarter = (container, cfg) => {
  startSKApp(container, cfg);
}